import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const useUrlSearch = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const urlParamsObject: {
    [key: string]: string;
  } = {};
  useEffect(() => {
    // 将查询参数转换为对象
    searchParams.forEach((value, key) => {
      urlParamsObject[key] = value;
    });
  }, []);

  return urlParamsObject;
};

export { useUrlSearch };
